import { render, staticRenderFns } from "./SentimentChip.vue?vue&type=template&id=5074c566&scoped=true&"
import script from "./SentimentChip.vue?vue&type=script&lang=js&"
export * from "./SentimentChip.vue?vue&type=script&lang=js&"
import style0 from "./SentimentChip.vue?vue&type=style&index=0&id=5074c566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074c566",
  null
  
)

export default component.exports